import React from 'react';
import { useTranslation } from 'react-i18next';
import { GenericTabs } from '@AMIEWEB/Common/Tabs/GenericTabs';
import { useParams } from 'react-router-dom';
import { FacilityOrderPayPackagesWrapper } from './OrderPayPackages/FacilityOrderPayPackagesWrapper';
import { FacilityPlacementPayPackagesWrapper } from './PlacementPayPackages/FacilityPlacementPayPackagesWrapper';

export const FacilityPayPackagesTab = () => {
  const { t } = useTranslation();
  const params = useParams<{ id: string }>();
  const facilityId = Number(params?.id);

  const tabs = [
    {
      label: t('order.payPackagesTab.orderPayPackages.title'),
      component: <FacilityOrderPayPackagesWrapper facilityId={facilityId} />,
    },
    {
      label: t('order.payPackagesTab.placementPayPackages.title'),
      component: <FacilityPlacementPayPackagesWrapper facilityId={facilityId} />,
    },
  ];

  return <GenericTabs tabs={tabs} hideHorizontalBorder />;
};
